import React from 'react';
import { FacebookIcon, PinterestIcon, PrintIcon, TwitterIcon } from "../Icons";
import './styles.scss';

type SocialShareProps = {
  message?: string;
}

const SocialShare = ({ message }: SocialShareProps) => {
  const link = typeof window !== 'undefined' ? encodeURI(window.location.href) : '';

  return (
    <div className={"social-share"}>
      <a
        href={`http://twitter.com/share?&url=${link}${!!message ? `&text=${encodeURI(message)}` : ''}`}
        target='_blank'
        className={"icon-item"}
      >
        <TwitterIcon />
      </a>
      <a
        href={`https://www.facebook.com/share.php?u=${link}`}
        target='_blank'
        className={"icon-item"}>
        <FacebookIcon />
      </a>
      <a href={`http://pinterest.com/pin/create/button/?url=${link}${!!message ? `&description=${encodeURI(message)}` : ''}`} target='_blank' className={"icon-item"}>
        <PinterestIcon />
      </a>
      <button
        type='button'
        className={"icon-item"}
        onClick={() => window.print()}
      >
        <PrintIcon />
      </button>
    </div>
  );
}

export default SocialShare;
